import * as React from "react";
import { useTranslation } from "react-i18next";

import { Grid, Typography } from "@mui/material";
import { Box } from "@mui/system";

import landingFacebook from "../common/svgs/landingFacebook.svg";
import landingInstagram from "../common/svgs/landingInstagram.svg";
import landingYoutube from "../common/svgs/landingYoutube.svg";
import logoBottom from "../common/svgs/logoBottom.svg";
import "./lotterySystem.css";

const LandingPageFooter: React.FC = () => {
  const { t } = useTranslation("translation");

  const openInNewTab = (url: string) => {
    const newWindow = window.open(url, "_blank");
    if (newWindow) {
      newWindow.focus();
    }
  };

  const gotoScroll = (id: string) => {
    const target = document?.getElementById(id);
    const targetIds = ["lottery-display", "features4", "about-us", "contact-us"];
    const windowScrollIds = ["digital-signage", "pricing"];
    if (target && targetIds.includes(id)) {
      target.scrollIntoView({ behavior: "smooth" });
    } else if(windowScrollIds.includes(id)) {
      const offset = target?.offsetTop;
      const headerHeight = 110; // Replace with your actual header height
      if(offset) {
        window.scrollTo({
          top: offset - headerHeight,
          behavior: "smooth",
        });
      }
    } else {
      target?.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <>
      <Grid>
        <Box className='landing-logo-bottom'>
          <img src={logoBottom} onClick={() => gotoScroll("landing-intro")} style={{
          cursor: "pointer"
        }} alt='logo bottom' width='80%' height='80%' />
        </Box>
        <Typography className='landing-footer-typo'>{t("footerInfo1")}</Typography>
        <Typography className='landing-footer-typo'>{t("footerInfo2")}</Typography>
        <Typography className='landing-footer-typo'>{t("footerInfo3")}</Typography>
      </Grid>
      <Grid>
        <Typography className='landing-footer-follow-us'>{t("followUs")}</Typography>
        <Grid display='flex'>
          <img
            className='landing-footer-social-icons'
            src={landingFacebook}
            onClick={() => openInNewTab("https://www.facebook.com/profile.php?id=61556226006007")}
            alt='logo bottom'
            width='40%'
            height='40%'
          />
          <img
            className='landing-footer-social-icons'
            src={landingInstagram}
            onClick={() => openInNewTab("https://www.instagram.com/digitech.express")}
            alt='logo bottom'
            width='40%'
            height='40%'
          />
          <img
          className="landing-footer-social-icons"
            src={landingYoutube}
            alt='logo bottom'
            onClick={() => openInNewTab("https://www.youtube.com/@digitechexpress")}
            width='40%'
            height='40%'
          />
        </Grid>
      </Grid>
    </>
  );
};

export default LandingPageFooter;
